import { Button } from '@rgrd/component-library'
import { useNavigate } from 'react-router'

import { useRegardAuth } from '~/shell/auth/useRegardAuth'

import styles from './UnauthorizedPage.module.css'

/**
 * The no-access page: shown when a session has no customer it may access — an
 * authenticated user who is neither a `regard_admin` nor carries a customer
 * claim, or one whose customer-scoped request was rejected with a
 * server-enforced 403.
 *
 * It carries the suite's only logout affordance outside the header, because it is
 * the one surface reached without one: a session that lands here has no customer,
 * so it has no app and no header above it, and without this it would be a dead end
 * escapable only by clearing browser storage by hand. The action is the **session
 * reset** at `/logout` rather than a plain **Log out** — whatever the user is
 * wedged on, this returns the browser to a cold start (see `LogoutRoute` and the
 * glossary entries in `GLOSSARY.md`). It is gated on **Can-logout** for the same
 * reason the user menu's is: in EMR-embedded mode the EHR owns the session and there is
 * nothing here to end.
 */
export const UnauthorizedPage = () => {
  const { canLogout } = useRegardAuth()
  const navigate = useNavigate()

  return (
    <main className={styles.container}>
      <div className={styles.card}>
        <h1 className={styles.heading}>No access</h1>
        <p className={styles.message}>
          Your account isn’t linked to a hospital you can view. Contact Regard
          support if you think this is a mistake.
        </p>
        {canLogout && (
          <div className={styles.action}>
            <Button
              intent="neutral"
              onClick={() => {
                void navigate('/logout')
              }}
              variant="outline"
            >
              Log out
            </Button>
          </div>
        )}
      </div>
    </main>
  )
}
